import { Line } from "vue-chartjs";
import axios from "axios"
export default {
    extends: Line,
    props: ['dataProp','dateProp','visits', 'success'],
    data() {
        return {
            dates:[],
            values:[],
            values2:[],
            chartDataGeneral: {
                labels: this.dateProp,
                datasets: [
                    {
                        label: 'Failure visits',
                        backgroundColor: "transparent",
                        borderWidth: 3,
                        borderColor: '#f491ab',
                        pointBackgroundColor: '#f491ab',
                        pointBorderWidth: 1,
                        pointBorderColor: '#f491ab',
                        data: this.values,
                        steppedLine: false,
                        borderJoinStyle: 'bevel',
                        capBezierPoints: true,
                        hoverBorderWidth: 0,
                        hoverBorderColor: '#f491ab',
                        stepped: true,
                        fill: true,
                        tension: 0,
                        lineTension: 0,
                        pointStyle: 'rectRounded',
                        hoverRadius: 2,
                        radius: 2
                    },
                    {
                        label: 'Success visits',
                        backgroundColor: "transparent",
                        borderWidth: 3,
                        borderColor: '#78bf88',
                        pointBackgroundColor: '#78bf88',
                        pointBorderWidth: 1,
                        pointBorderColor: '#78bf88',
                        data: this.values2,
                        steppedLine: false,
                        borderJoinStyle: 'bevel',
                        capBezierPoints: true,
                        hoverBorderWidth: 0,
                        hoverBorderColor: '#78bf88',
                        stepped: true,
                        fill: true,
                        tension: 0,
                        lineTension: 0,
                        pointStyle: 'rectRounded',
                        hoverRadius: 2,
                        radius: 2
                    }
                ]
            },
            chartOptionsGeneral: {
                responsive: true,
                maintainAspectRatio: false,
                title: {
                    display: false,
                    text: 'Chart.js Doughnut Line'
                },
                scales: {
                    xAxes: [{
                        position: 'bottom',
                        gridLines: {

                        },
                        scaleLabel: {
                            display: true,
                            labelString: ''
                        },
                        ticks: {
                            maxRotation: 0,
                            reverse: false,
                            padding: 0,

                        }
                    }],
                    yAxes: [{
                        position: 'left',
                        gridLines: {

                        },
                        scaleLabel: {
                            display: true,
                            labelString: ''
                        },
                        ticks: {
                            min: 0,
                            stepSize: 1
                        }
                    }],
                },
                plugins: {
                    zoom: {
                        pan: {
                            enabled: true,
                            mode: 'xy'
                        },
                        zoom: {
                            enabled: true,
                            mode: 'xy'
                        }
                    }
                },
                legend: {
                    display: false,
                    position: 'bottom',
                }
            },
            afterDraw(chart, args, options) {
                const {datasets} = chart.data
                let hasData = false
                for (let dataset of datasets) {
                    if (dataset.data.length > 0 && dataset.data.some(item => item !== 0)) {
                        hasData = true;
                        break;
                    }
                }

                if (!hasData) {
                    this.emit({type: 'generalChart', isEmpty: true})
                } else {
                    this.emit({type: 'generalChart', isEmpty: false})
                }
            }
        }
    },
    mounted () {
        this.addPlugin({id: 'generalChart', afterDraw: this.afterDraw, emit: (args) => this.$emit('empty-chart', args)})
        this.renderChart(this.chartDataGeneral, this.chartOptionsGeneral)
    },

    created() {
        //this.dataProp.forEach(element => this.dates.push(element.date))
        this.dates = this.dateProp
        this.values = this.visits
        //this.visits.forEach(element => this.values.push(element.data))
        //this.success.forEach(element => this.values2.push(element.data))
        this.values2 = this.success
        this.chartDataGeneral.labels = this.dates
        this.chartDataGeneral.datasets[0].data = this.values
        this.chartDataGeneral.datasets[1].data = this.values2
        this.today()


    },
    methods: {
        today() {
            let date = new Date()
            return (date.getDate())
        }
    }
};
